var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt2-sg wt2-masthead-home-icon",on:{"click":_vm.goToHome}},[_c('i',{staticClass:"wticon wticon-logo-icon"})])}]

export { render, staticRenderFns }